import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateTaskFileGroupTypeService } from './update/update-task-file-group-type.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    UpdateTaskFileGroupTypeService
  ],
})
export class TaskFileGroupTypesModule {}
